import { render } from "./detail.vue?vue&type=template&id=0bd50d6b&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0bd50d6b&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=0bd50d6b&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd50d6b"]])

export default __exports__